/** @format */
import {HEADER_ROUTES} from '../../constants';

const getActivePath = (pathname: string): string | null => {
  const allRoutes = Object.values(HEADER_ROUTES) as string[];
  return allRoutes.find(route => route === pathname) || null;
};

export {getActivePath};
